import { CortexSetting, LocationVarKey } from "@swivl-mono/types";

import { CortexSettingRow } from "../../Components/CortexSettingRow";

export const TOPIC_VARS: LocationVarKey[] = [LocationVarKey.CortexFacilityGateCodeInstructions];

const GATE_CODE_INSTRUCTIONS_SETTING: CortexSetting = {
  kind: "text",
  key: "gateCodeInstructions",
  varKey: LocationVarKey.CortexFacilityGateCodeInstructions,
  label: "Gate code keypad instructions",
  description:
    "Per-facility keypad instructions appended whenever the bot delivers a gate code (e.g. 'Press # then your code'). Leave blank to deliver only the code.",
  placeholder: "Press # then your code",
  default: ""
};

export function GateCodeTopic(): React.ReactElement {
  return (
    <section className="rounded-lg border border-grey-200 bg-white p-5">
      <CortexSettingRow setting={GATE_CODE_INSTRUCTIONS_SETTING} />
    </section>
  );
}
